import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const OAuth2AppDirectoryTimeline: React.FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Apps' {...props} />
}
